module.exports = "/_next/static/images/1f9af155617797d2e7a15ff0994ce304-card-xs.png";